module.exports = __webpack_public_path__ + "static/voyayge-hrt-94b8322dffccbd38700a76e6c2dc42ec.png";